import { Group, SegmentedControl, Stack, Text } from "@mantine/core";
import { useNavigate, useParams, useRouteLoaderData } from "react-router-dom";
import { IconSettings, IconUsers } from "@tabler/icons-react";
import CommunityDropdown from "../resellers/CommunityDropdown";
import CreateUser from "../../resellers/createUser/CreateUserButton";
import OrgUsers from "./OrgUsers";
import OrgSettings from "./OrgSettings";
import { useLanguage } from "../../../../stores/LanguageStore";

const OrgPage = () => {
  const lang = useLanguage((s) => s.language);
  const organization = useRouteLoaderData("organization");
  const { tab } = useParams();
  const navigate = useNavigate();
  return (
    <Stack gap={0} pr={48} pt={32}>
      <Group>
        <CommunityDropdown
          getClickLink={(id) => `/settings/organizations/${id}`}
          getDeletedLink={(id) => `/settings/organizations/`}
          type="organizations"
        />

        <SegmentedControl
          w={500}
          mx={"auto"}
          size="md"
          value={tab}
          data={[
            {
              label: (
                <Group justify="center">
                  <IconUsers />

                  <Text>{lang.white_labels.users}</Text>
                </Group>
              ),
              value: "users",
            },
            {
              label: (
                <Group justify="center">
                  <IconSettings />

                  <Text>{lang.white_labels.settings}</Text>
                </Group>
              ),
              value: "settings",
            },
          ]}
          onChange={(v) => {
            navigate(`/settings/organizations/${organization.id}/${v}`);
          }}
        />

        <CreateUser parentUrl={`/settings/organizations/${organization.id}/`} />
      </Group>

      {tab === "users" ? <OrgUsers /> : <OrgSettings />}
    </Stack>
  );
};

export default OrgPage;
